import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'danishNumber'})
export class ReverseStr implements PipeTransform {
  transform(value: any, digtigs: number = 2) {
    if (value != null)
      return value.toLocaleString('da', {minimumFractionDigits: digtigs, maximumFractionDigits: digtigs})
  }
}
